const facts = [
  {
    step: '1',
    stat: '1 / 3,400 sq km',
    detail: "Approx. warden coverage pressure across Canada's national parks and reserves.",
  },
  {
    step: '2',
    stat: '37 + 11',
    detail: 'National parks and national park reserves across mountains, forests, tundra, and glaciers.',
  },
  {
    step: '3',
    stat: 'Permit only',
    detail: 'UAV access is restricted, but can support resource protection, public safety, and enforcement.',
  },
  {
    step: '4',
    stat: 'Complex terrain',
    detail: 'Autonomous robots can collect repeatable field data where manual monitoring is slow or risky.',
  },
];

export function ParkFactsStrip() {
  return (
    <section className="bg-neutral-950 px-4 pb-14 pt-10 text-neutral-100 md:px-8 md:pb-20 md:pt-12">
      <div className="mx-auto w-full max-w-7xl">
        <div className="grid gap-8 md:grid-cols-4 md:gap-6">
          {facts.map((fact, index) => (
            <div key={fact.step} className="relative">
              <article
                tabIndex={0}
                className="group h-40 outline-none [perspective:1000px]"
              >
                <div
                  className="relative h-full transition-transform duration-500 group-focus:[transform:rotateY(180deg)] group-hover:[transform:rotateY(180deg)]"
                  style={{ transformStyle: 'preserve-3d' }}
                >
                  <div
                    className="absolute inset-0 flex flex-col items-center justify-center rounded-xl border border-neutral-300 bg-white px-4 py-4 text-center text-neutral-950 shadow-sm"
                    style={{ backfaceVisibility: 'hidden' }}
                  >
                    <div className="flex h-6 w-6 items-center justify-center rounded-full border border-neutral-300 text-[0.65rem] font-bold text-neutral-500">
                      {fact.step}
                    </div>
                    <p className="mt-3 text-2xl font-semibold tracking-tight md:text-3xl">
                      {fact.stat}
                    </p>
                  </div>
                  <div
                    className="absolute inset-0 flex flex-col items-center justify-center rounded-xl border border-white/20 bg-neutral-900 px-4 py-4 text-center text-neutral-100 shadow-sm"
                    style={{ backfaceVisibility: 'hidden', transform: 'rotateY(180deg)' }}
                  >
                    <p className="text-xs font-bold uppercase tracking-[0.18em] text-white">
                      Fact {fact.step}
                    </p>
                    <p className="mt-3 max-w-xs text-sm leading-6 text-white">
                      {fact.detail}
                    </p>
                  </div>
                </div>
              </article>
              {index < facts.length - 1 ? (
                <span className="mx-auto mt-4 block text-center text-2xl text-neutral-500 md:absolute md:right-[-1.05rem] md:top-1/2 md:z-10 md:mt-0 md:-translate-y-1/2 md:px-1">
                  {'->'}
                </span>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
